import {HTTP} from '@/services/http-common'
import * as types from '../mutation-types'

const state = {
  changeLog: []
}

const getters = {
  changeLog: state => state.changeLog
}

const actions = {
  getChangeLog ({ commit }, params) {
    return HTTP.get('/change_logs', {
      params: params
    }).then(resp => {
      commit(types.SET_CHANGE_LOG, resp.data["hydra:member"])
      return resp.data["hydra:member"]
    }, error => {
      console.log(error)
    })
  },
  postChangeLog ({ commit }, params) {
    return HTTP.post('/change_logs', params).then(resp => {
      commit(types.ADD_CHANGE_LOG, resp.data)
      return resp.data
    }, error => {
      console.log(error)
    })
  },
  putChangeLog ({ commit }, params) {
    return HTTP.put('/change_logs/' + params.id, params).then(resp => {
      return resp.data
    }, error => {
      console.log(error)
    })
  },
  deleteChangeLog ({ commit }, id) {
     return HTTP.delete('/change_logs/' + id).then(() => {}, error => {
      console.log(error)
    })
  },
  resetChangeLog ({ commit }) {
    commit(types.SET_CHANGE_LOG, [])
  }
}

const mutations = {
  [types.SET_CHANGE_LOG] (state, data) {
    state.changeLog = data
  },
  [types.ADD_CHANGE_LOG] (state, data) {
    state.changeLog.push(data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
